import decorateLocation from 'onyx-common/decorateLocation'

const getCurrentDecoratedLocation = (win = window) => {
  return decorateLocation(win.location)
}

export default getCurrentDecoratedLocation
